// External
import React, { useContext, useMemo } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { ButtonStyled, TextStyled, useTokens } from '@nike/nike-design-system-components';
import { Box, Flex } from 'rebass';

import { TableServerSideContext } from '~COMPONENTS/tableServerSide/TableServerSideContext';
import TableServerSide from '../../components/tableServerSide/TableServerSide';
import IconMenu from '../../components/IconMenu';

import { getCatalogTypesListColumns } from './columns';

const CatalogTypes = () => {
  const { url } = useRouteMatch();

  const tokens = useTokens();

  const memoizedColumns = useMemo(() => getCatalogTypesListColumns(), []);

  const { tableInstance, setAllFilters, setSortBy, totalResources, columnSortModifiers } =
    useContext(TableServerSideContext);

  const { sortBy } = tableInstance;

  const handleClearSortAndFilters = () => {
    const defaultSortKeys = Object.keys(columnSortModifiers.defaultSort) || [];
    const isDefaultSortApplied =
      sortBy && defaultSortKeys.every(defaultSortKey => sortBy[defaultSortKey] !== undefined);

    setSortBy(isDefaultSortApplied ? columnSortModifiers.defaultSort : {});
    setAllFilters([]);
  };

  return (
    <Box style={{ backgroundColor: tokens.podiumCdsColorGrey50 }}>
      <Flex
        sx={{
          borderBottom: `1px solid ${tokens.podiumCdsColorGrey200}`,
          padding: '12px',
          width: '100%'
        }}
      >
        <TextStyled appearance='title2'>Catalog Types</TextStyled>
      </Flex>
      <Flex p='12px' width='100%'>
        <Flex alignItems='center' width='50%'>
          <TextStyled appearance='body2' style={{ marginLeft: '5px' }}>
            {`${totalResources}`} results
          </TextStyled>

          <ButtonStyled
            appearance='text'
            background='light'
            ariaLabel='Clear All Filters'
            type='button'
            onClick={handleClearSortAndFilters}
            style={{ marginLeft: '20px', marginRight: '20px' }}
          >
            Clear All Filters
          </ButtonStyled>
        </Flex>

        <Flex justifyContent='flex-end' width='50%'>
          <IconMenu align='right' menuOptions={[{ text: 'Add Catalog Type', to: `${url}/new` }]} />
        </Flex>
      </Flex>

      <Box px='12px'>
        <TableServerSide columns={memoizedColumns} url='v1/catalogTypes' fullHeight fullWidth />
      </Box>
    </Box>
  );
};

export default CatalogTypes;
